import {get, isNull} from 'lodash';
import {globalError} from "modules/actions/errors";
import {getPlayingUsersSuccess, setPlayingContestUsersSuccess} from "modules/actions/here_now_users";
import {getActualContest} from "modules/selectors/contests_trivia";
import {ISagaAction} from "modules/types";
import {TriviaApi} from "modules/utils/Api";
import {TIMINGS} from "modules/utils/trivia";
import {SagaIterator} from "redux-saga";
import {call, delay, put, select} from "typed-redux-saga";

export const setPlayingContestUsers = function* (action: ISagaAction<number>): SagaIterator {
	const contest = yield* select(getActualContest);
	const now = new Date().getTime();

	if ( contest ) {
		const startTime = new Date(contest.start_date_time).getTime();
		const deltaTime = startTime - now;

		if ( deltaTime <= TIMINGS.set_user_as_playing_before ) {
			yield* call(TriviaApi.User.play_contest_user, contest.id);
			yield* put(setPlayingContestUsersSuccess(action.payload))
		} else if (deltaTime  > 0) {
			yield* delay(TIMINGS.ONE_MIN);
			yield* call(setPlayingContestUsers, action)
		}
	}
};


export const getPlayingContestUsers = function* (): SagaIterator {
	try {
		const contest = yield* select(getActualContest);

		if ( !contest ) {
			return
		}
		const is_ended = new Date(contest.end_date_time).getTime() < new Date().getTime();

		if ( is_ended ) {
			return
		}

		if ( contest ) {
			const is_started = new Date(contest.start_date_time).getTime() < new Date().getTime();

			const delay_time = is_started ?
				TIMINGS.time_to_update_playing_users_live :
				TIMINGS.time_to_update_playing_users_scheduled;

			const result = yield* call(TriviaApi.User.play_contest_user_count, contest.id);
			const count = get(result, 'result.count', null);

			if ( !isNull(count) ) {
				yield* put(getPlayingUsersSuccess(result.result.count));
			}

			yield* delay(delay_time);
			yield* call(getPlayingContestUsers);
		} else {
			yield* delay(TIMINGS.ONE_MIN);
			yield* call(getPlayingContestUsers)
		}
	} catch (e: any) {
		console.log(e);
		yield* delay(5 * TIMINGS.ONE_MIN);
		yield* call(getPlayingContestUsers);
		yield* put(globalError(e))
	}
};
